import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import {IoCheckmarkCircle, IoAlertCircle, IoDocument, IoCloudUpload} from 'react-icons/io5';
import * as yup from 'yup';
import "./DevelopmentNewCase.css";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import docIcon from './document.png';
import {useNavigate} from "react-router-dom";
import CustomAlert from "../../../components/ConfirmationModal/CustomAlert";
import CaseFilesStatus from "../../../enums/CaseFilesStatus";
import CaseFilesInternal from "../../../enums/CaseFilesInternal";
import CaseFileDeclined from "../../../enums/CaseFileDeclined";
import {MdDeleteForever} from "react-icons/md";
import {Tooltip} from "@mui/material";
import LoaderCustom from "../../../components/ConfirmationModal/LoaderCustom";
import {jwtDecode} from "jwt-decode";


const DevelopmentNewCaseExpert = () => {
    const [fileTypes, setFileTypes] = useState([]);
    const [uploadProgress, setUploadProgress] = useState({});
    const [uploadedFiles, setUploadedFiles] = useState({});
    const [fileErrors, setFileErrors] = useState({});
    const [isUploading, setIsUploading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const fileInputRefs = useRef({});
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("");
    const params = new URLSearchParams(window.location.search);
    const caseId = parseInt(params.get('id'), 10);
    const caseType = parseInt(params.get('caseid'), 10);
    const navigate = useNavigate();
    const [formattedFileNames, setFormattedFileNames] = useState({});
    const [isNoButtonDisabled, setIsNoButtonDisabled] = useState(false);
    const [modalText, setModalText] = useState("დარწმუნებული ხართ?");
    const [isAccelerationEnabled, setIsAccelerationEnabled] = useState(false);
    const [allRequiredUploaded, setAllRequiredUploaded] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingFileTypes, setIsLoadingFileTypes] = useState(true);
    const token = localStorage.getItem("jwtToken");
    const [userRole, setUserRole] = useState(null);

    useEffect(() => {
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setUserRole(decoded.role);
            } catch (error) {
                setUserRole("");
            } finally {
            }
        }
    }, [token]);

    //
    // useEffect(() => {
    //     const fetchCaseDetails = async () => {
    //         try {
    //
    //             const caseId = new URLSearchParams(window.location.search).get('caseid');
    //             const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetCaseByIdByuser?Id=${caseId}`);
    //             if (response.data.success && response.data.data.status !== 1) {
    //                 navigate(`/dashboard/mycases/casemanager?id=${caseId}`);
    //                 setIsLoading(false)
    //             } else {
    //                 setIsLoading(false)
    //             }
    //
    //         } catch (error) {
    //             console.error('Failed to fetch case details:', error);
    //         }
    //     };
    //
    //     void fetchCaseDetails();
    // }, []);

    const checkAllRequiredUploaded = () => {
        const allUploaded = fileTypes.every(fileType => {
            return !fileType.required || (fileType.required && uploadedFiles[fileType.id]);
        });
        setAllRequiredUploaded(allUploaded);
    };


    const fetchCaseDetails = async () => {
        setIsLoading(true)
        try {
            const caseId = parseInt(params.get('caseid'), 10);
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetCaseByIdByuser?Id=${caseId}`);
            if (response.data.success) {
                setIsAccelerationEnabled(response.data.data.acceleration);
            }
        } catch (error) {
        }
        setIsLoading(false)
    };


    useEffect(() => {
        const fetchData = async () => {
            setIsLoadingFileTypes(true)
            await fetchCaseDetails()
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllFileTypes`);
                if (response.data.success) {
                    let filteredData = response.data.data.filter(fileType => fileType.caseId === caseId);
                    if (!isAccelerationEnabled) {
                        filteredData = filteredData.filter(fileType => !fileType.isCheck);
                    }
                    filteredData = filteredData.map(fileType => ({
                        ...fileType,
                        required: false,
                    }));
                    filteredData.sort((a, b) => a.sort - b.sort);
                    setFileTypes(filteredData);
                    filteredData.forEach(fileType => {
                        fileInputRefs.current[fileType.id] = React.createRef();
                        setUploadProgress(prevState => ({...prevState, [fileType.id]: 0}));
                        setUploadedFiles(prevState => ({...prevState, [fileType.id]: null}));
                        setFileErrors(prevState => ({...prevState, [fileType.id]: null}));
                    });
                }
            } catch (error) {
            }
            setIsLoadingFileTypes(false)
        };
        void fetchData();
    }, [caseId, isAccelerationEnabled]);

    const handleBoxClick = (fileTypeId) => {
        fileInputRefs.current[fileTypeId].current.click();
    };

    const handleFileChange = (fileType, event) => {
        const file = event.target.files[0];

        if (file) {
            let formattedName = file.name;
            if (formattedName.length > 30) {
                const fileExtension = formattedName.substring(formattedName.lastIndexOf('.'));
                formattedName = formattedName.substring(0, 27) + '...' + fileExtension;
            }

            setFormattedFileNames(prevState => ({...prevState, [fileType.id]: formattedName}));
            const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
            const maxSizeBytes = 5000 * 1048576; // 1 MB = 1048576 bytes

            if (file.size > maxSizeBytes) {
                setFileErrors(prevState => ({
                        ...prevState,
                        [fileType.id]: `ფაილის ზომა აღემატება 5000MB.`

                    })
                );
                if (fileInputRefs.current[fileType.id]) {
                    fileInputRefs.current[fileType.id].current.value = "";
                }
                return;
            }
            if (!fileType.extension.includes(fileExtension)) {
                setFileErrors(prevState => ({...prevState, [fileType.id]: "არასწორი ფორმატი!"}));
                setFormattedFileNames(prevState => ({...prevState, [fileType.id]: ''}));
            } else {
                setFileErrors(prevState => ({...prevState, [fileType.id]: null}));

                setUploadedFiles(prevState => ({...prevState, [fileType.id]: file}));

                let progress = 0;
                const interval = setInterval(() => {
                    progress += 10;
                    setUploadProgress(prevState => ({...prevState, [fileType.id]: progress}));
                    if (progress >= 100) {
                        clearInterval(interval);
                    }
                }, 200);
            }


            event.target.value = null;
            checkAllRequiredUploaded();
        }
    };


    const handleViewDocument = (fileType) => {
        const file = uploadedFiles[fileType.id];
        if (file) {
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL, '_blank');
            URL.revokeObjectURL(fileURL);
        }
    };

    const validateUploads = async () => {
        let schema = yup.object().shape({});
        fileTypes.forEach(fileType => {
            if (fileType.required) {
                schema = schema.shape({
                    [fileType.id]: yup.mixed().required(`დოკუმენტი სავალდებულოა!`)
                });
            }
        });

        try {
            await schema.validate(uploadedFiles, {abortEarly: false});
            return true;
        } catch (err) {
            err.inner.forEach(error => {
                setFileErrors(prev => ({...prev, [error.path]: error.message}));
            });
            return false;
        }
    };

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const base64String = reader.result.split(',')[1];
            resolve(base64String);
        };
        reader.onerror = error => reject(error);
    });

    const performUpload = async () => {
        setIsUploading(true);
        setIsNoButtonDisabled(true);

        let allUploadsSuccessful = true;

        for (const fileType of fileTypes) {
            const file = uploadedFiles[fileType.id];
            if (file) {
                const fileBase64 = await toBase64(file);
                const name = fileType.title;
                const fileData = {
                    caseID: caseType,
                    name: name,
                    ext: file.name.split('.').pop(),
                    file: fileBase64,
                    mainInfo: "",
                    additionalInfo: "",
                    shared: true,
                    blank: false,
                    documentType: 0,
                    internal: CaseFilesInternal.No,
                    status: CaseFilesStatus.Sent,
                    decline: CaseFileDeclined.No,
                    fileTypeId: fileType.id,
                    declinedInternalStatus: 0,
                    registeryDocumentType: fileType.registeryDocumentType,
                    inActiveIsInspectionSertificate: fileType.isinspectionSertificate
                };
                try {
                    await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, fileData);
                } catch (error) {
                    setAlertMessage("Upload failed: " + error.message);
                    setAlertType("error");
                    setShowAlert(true);
                    allUploadsSuccessful = false;
                }
            }
        }

        setIsUploading(false);
        setIsNoButtonDisabled(false);
        setModalText("დარწმუნებული ხართ?");
        if (allUploadsSuccessful && userRole === "ROOTADMIN") {
            navigate("/agencyanswers");
            return
        }

        if (allUploadsSuccessful) {
            navigate("/dashboard/registery");
        }
    };


    const handleDeleteFile = (fileType) => {
        setUploadedFiles(prevState => ({...prevState, [fileType.id]: null}));
        setUploadProgress(prevState => ({...prevState, [fileType.id]: 0}));
        setFileErrors(prevState => ({...prevState, [fileType.id]: null}));
        setFormattedFileNames(prevState => ({...prevState, [fileType.id]: ''}));
        checkAllRequiredUploaded();
    };

    useEffect(() => {
        checkAllRequiredUploaded();
    }, [fileTypes, uploadedFiles]);
    const handleUploadFiles = async () => {
        if (!await validateUploads()) {
            return;
        }
        setIsModalOpen(true);
    };

    return (
        <div>

            {isLoading || isLoadingFileTypes ? (
                <LoaderCustom/>

            ) : (
                <div>
                    <div className="file-upload-page">

                        <div className="top-right-tooltip">
                            <Tooltip
                                title={(isUploading || !allRequiredUploaded) ? "განაცხადის რეგისტრაცისთვის ატვირთეთ ყველა სავალდებულო დოკუმენტი!" : ""}
                            >
                                <button onClick={handleUploadFiles}
                                        disabled={isLoading || isUploading || !allRequiredUploaded || isLoadingFileTypes}
                                        className="upload-button">
                                    <IoCloudUpload size="24px" className="upload-icon"/>
                                    {isUploading ? 'განაცხადი იგზავნება...' : 'განაცხადის შექმა'}
                                </button>
                            </Tooltip>
                        </div>

                        <div className="file-upload-container">
                            {fileTypes.map(fileType => (
                                <div>
                                    <div key={fileType.id}
                                         className={`file-box ${uploadProgress[fileType.id] === 100 ? 'upload-complete' : ''}`}
                                         onClick={() => handleBoxClick(fileType.id)}>
                                        <img src={docIcon} alt="Document" className="document-icon"/>
                                        <div className="file-content">
                                            <div className="file-top">
                                                <div>
                                                    <h4 className={"documnet-title"}>{fileType.title}</h4>
                                                    <div
                                                        className={"documnet-title"}>გაფართოება: {fileType.extension}</div>
                                                    <div className={"documnet-title"}>მაქსიმალური
                                                        ზომა: 5000MB.
                                                    </div>
                                                    <div
                                                        className={"documnet-title"}>{formattedFileNames[fileType.id]}
                                                    </div>
                                                </div>
                                                {fileType.required && uploadProgress[fileType.id] !== 100 && (
                                                    <div className="icon-container">
                                                        <IoAlertCircle color="red" fontSize={"24px"}/>
                                                    </div>
                                                )}
                                                {uploadProgress[fileType.id] === 100 && (
                                                    <div className="icon-container">
                                                        <IoCheckmarkCircle size="24px" color="green"/>
                                                    </div>
                                                )}
                                            </div>
                                            {fileErrors[fileType.id] &&
                                                <div className="error-message-doc">{fileErrors[fileType.id]}</div>}


                                            <input
                                                type="file"
                                                ref={fileInputRefs.current[fileType.id]}
                                                style={{display: 'none'}}
                                                accept={`${fileType.extension}`}
                                                onChange={(e) => handleFileChange(fileType, e)}
                                            />
                                        </div>
                                    </div>

                                    {uploadProgress[fileType.id] === 100 && (
                                        <div className="documnet-actions-contaioner">

                                            <button className={"view-doc-button"}
                                                    onClick={() => handleViewDocument(fileType)}>
                                                <IoDocument/> ნახვა
                                            </button>
                                            <button className={"view-del-button"}
                                                    onClick={() => handleDeleteFile(fileType)}>
                                                <MdDeleteForever/> წაშლა
                                            </button>

                                        </div>

                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

            )}
            <div>
                <ConfirmationModal
                    isOpen={isModalOpen}
                    onRequestClose={() => setIsModalOpen(false)}
                    onConfirm={performUpload}
                    isNoButtonDisabled={isNoButtonDisabled}
                    modalText={modalText}
                />
                {showAlert && (
                    <CustomAlert
                        message={alertMessage}
                        type={alertType}
                        onClose={() => setShowAlert(false)}
                    />
                )}
            </div>
        </div>
    );
};

export default DevelopmentNewCaseExpert;
